import validator from 'validator';
export function useValidation() {
  const isGuid = (testString) => {
    return testString != null && true && validator.isUUID(testString) && testString !== '00000000-0000-0000-0000-000000000000';
  }
  const isAdminOfClub = (player,clubId) => {
    return player.adminFor && player.adminFor.includes(clubId)
  }
  const isExpiredUnvalidatedPlayer = (player) =>{
    return player.userVerificationTokens.length > 0 && player.userVerificationTokens.every(_ => _.expired) && !isGuid(player.userId)
  }
  const isPendingUnvalidatedPlayer = (player) =>{
    return player.userVerificationTokens.some(_ => _.expired === false) && !isGuid(player.userId)
  }
  const isAdminControlledPlayer = (player) => {
    return !isGuid(player.userId) && player.userVerificationTokens.length === 0
  }
  const isPlayerInTeam = (playerId,team) => {
    return team.players.some(_ => _.userId === playerId)
  }
  const teamIdFromPlayerInFixture = (playerId,fixture) => {
    return isPlayerInTeam(playerId,fixture.awayTeam) ? fixture.awayTeamId : (isPlayerInTeam(playerId,fixture.homeTeam) ? fixture.homeTeamId : null);
  }
  const isPlayerInFixture = (playerId,fixture) => {
    if(fixture.awayTeam == null || fixture.homeTeam == null || !playerId) return false;
    return isPlayerInTeam(playerId,fixture.awayTeam) || isPlayerInTeam(playerId,fixture.homeTeam)
  }
  const isUserInTeam = (userId,team) => {
    return team.players.some(_ => _.userId === userId)
  }
  const isApprovedFixture = (fixture) => {
    return fixture.approvedAt != null
  }
  const fixtureNeedsApprovalFromPlayerId = (fixture,playerId) => {
    let teamId = teamIdFromPlayerInFixture(playerId,fixture);
    if(teamId == null) return false;
    if(teamId === fixture.homeTeamId && fixture.homeTeamApprovedAt == null) return true;
    if(teamId === fixture.awayTeamId && fixture.awayTeamApprovedAt == null) return true;
    return false;
  }
  const myTeamFromListOfTeams = (playerId,teams) => {
    return teams.find(_ => isPlayerInTeam(playerId,_))
  }
  const isPlayersChallenge = (playerId,challenge) => {
    if(challenge == null || challenge.challengingTeam == null || challenge.challengedTeam == null) return false;
    return isPlayerInTeam(playerId,challenge.challengingTeam) || isPlayerInTeam(playerId,challenge.challengedTeam);
  }

  return {
    isGuid,
    isExpiredUnvalidatedPlayer,
    isPendingUnvalidatedPlayer,
    isAdminControlledPlayer,
    isPlayerInFixture,
    isUserInTeam,
    teamIdFromPlayerInFixture,
    fixtureNeedsApprovalFromPlayerId,
    isApprovedFixture,
    myTeamFromListOfTeams,
    isPlayersChallenge,
    isAdminOfClub
  };
}

